import PrimaryImageUpload from "./primaryImageUpload";



const AddItemImageUpload = (props) => {
  const images = Array.isArray(props?.getListToEdit) ? props.getListToEdit : [];

  return (
    <>
      <div className="flex flex-col items-center justify-center">
        {/* Top image */}
        <div className="mb-4">
          <PrimaryImageUpload
            defaultImage={images[0]?.image_url}
            Item_Id={props?.Item_Id}
            imageId={images[0]?.image_id}
            index={0}
          />
        </div>

        {/* Bottom four images */}
        <div className="grid grid-cols-4 gap-4">
          <PrimaryImageUpload
            defaultImage={images[1]?.image_url}
            Item_Id={props?.Item_Id}
            imageId={images[1]?.image_id}
            index={1}
          />
          <PrimaryImageUpload
            defaultImage={images[2]?.image_url}
            Item_Id={props?.Item_Id}
            imageId={images[2]?.image_id}
            index={2}
          />
          <PrimaryImageUpload
            defaultImage={images[3]?.image_url}
            Item_Id={props?.Item_Id}
            imageId={images[3]?.image_id}
            index={3}
          />
          <PrimaryImageUpload
            defaultImage={images[4]?.image_url}
            Item_Id={props?.Item_Id}
            imageId={images[4]?.image_id}
            index={4}
          />
        </div>
        <small>NB - You can replace an image by clicking on it</small>
      </div>
    </>
  );
};
export default AddItemImageUpload;